var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontStomach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 38,
    viewBox: "0 0 50 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3666 3.89748C16.5481 3.85388 5.47034 0.949954 4.8147 1.27541C4.15906 1.60087 4.8147 5.20676 4.48688 5.86497C4.15906 6.52319 2.84778 9.46855 3.83124 15.3717C4.8147 21.275 1.42723 28.0475 0.880859 31.7627C24.8117 44.5477 49.0704 32.4184 49.3982 31.7627C49.6605 31.2382 44.8087 18.6525 45.7922 14.3883C46.7756 10.1241 44.8087 4.88152 44.8087 4.88152C44.8087 4.88152 44.918 2.04033 44.8087 1.27541C44.8087 1.27541 32.5305 3.943 24.3666 3.89748Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontStomach);
export default __webpack_public_path__ + "static/media/FrontStomach.b68c01396fb3ad33b5b23d83c6941dfd.svg";
export { ForwardRef as ReactComponent };